import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import { StyledPropertyCardSaveArea } from './PropertyCardSaveArea.styles';

/**
 * A container for the save button in a `PropertyCard`.
 *
 * @since 8.67.0
 */
export var PropertyCardSaveArea = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  return /*#__PURE__*/React.createElement(StyledPropertyCardSaveArea, _extends({
    ref: forwardedRef
  }, props));
});
PropertyCardSaveArea.displayName = 'PropertyCard.SaveArea';